'use es6';

import { List, is } from 'immutable';
import { Promise } from '../../lib/promise';
const SCRIPTED = 'BUCKET_createdate_enteredCount';
const PROCESSOR = 'bucket:created';
export const matchCreated = config => is(config.get('dimensions'), List.of(SCRIPTED));
export const configure = config => {
  return Promise.resolve(matchCreated(config) ? config.update('processors', context => context.push(PROCESSOR)) : config);
};